module.exports = __webpack_public_path__ + "static/media/pjulio.f0fced7c.jpg";